import AutoTrackBeacon from '@tencent/autotracker-beacon-oa';
import scroll from '@tencent/autotracker-beacon-oa/dist/plugin/scroll';

export const CLICK_REPORT = 'auto-tracker-click-report';

/** 上报字段 A306 为 url 的查询参数 */
const SEARCH_KEY = 'A306';
const APP_KEY = '0WEB06MXB8SAL9JR';
const GUEST_FINGER_KEY = 'guestFingerUid';

const getGuestFingerUid = () => {
  let uid = localStorage.getItem(GUEST_FINGER_KEY);
  if (uid) return uid;

  uid = `GUEST_${randomString(16)}`;
  localStorage.setItem(GUEST_FINGER_KEY, uid);

  return uid;
};

const getUserRtx = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return '';

    const user = JSON.parse(userStr);
    return user?.uid || '';
  } catch (error) {
    return '';
  }
};

let autoTrackBeaconInstance;

export const initAutoTrackBeacon = () => {
  autoTrackBeaconInstance = new AutoTrackBeacon({
    report: {
      appkey: APP_KEY,
      beforeReport(type, params) {
        return {
          ...params,
          rtx: getUserRtx() || getGuestFingerUid(),
          ms_timestamp: Date.now(),
          title: document.title,
          [SEARCH_KEY]: params[SEARCH_KEY],
        };
      },
    },
  });

  autoTrackBeaconInstance.config('Click', {
    autoSelector: ['button', 'a', `.${CLICK_REPORT}`],
  });

  autoTrackBeaconInstance.use(scroll, {
    scrollPageDelay: 5000,
    containerSelector: ['.galiosight-home'],
  });

  // 初始化
  autoTrackBeaconInstance.init();
};
